import React from 'react';
import PageFrame from 'components/common/PageFrame';
import CoreTechnologyTab from 'components/menu/research/CoreTechnologyTab';
import SupportToolTab from 'components/menu/research/SupportToolTab';
import menuItems from 'assets/data/menuItems.json';

const ResearchPage = () => {

    const showTab = (id) => {
        switch (id) {
            case 0:
                return <CoreTechnologyTab />
            case 1:
                return <SupportToolTab />
            default: return;
        }
    }

    return (
        <section className='ResearchPage'>
            <PageFrame subMenuItems={menuItems[2].tabs} showTab={showTab} rest={65} page={'research'} />
        </section>
    );
};

export default ResearchPage;